<template>
  <div class="mFooter-container">
    <div class="mLogo-container">
      <img :src="indioIcon" />
    </div>
    <div class="mPrivacy-container">
      <div class="mPrivacy-links">
        <h4 v-if="showInfoOption" class="privacy clickable nomobile" @click="(showModalInfo = true) & footerGA4Click('click', 'informacion del producto', 'footer')">
          Información del producto
        </h4>
        <span v-if="showInfoOption" class="privacy bar nomobile">|</span>
        <h4 class="privacy clickable" @click="footerGA4Click('click', 'terminos y condiciones', 'footer') & $router.push('/tycos')">
          Términos y Condiciones
        </h4>
        <span class="privacy bar">|</span>
        <h4 class="privacy clickable" @click="footerGA4Click('click', 'aviso de privacidad', 'footer') & $router.push('/politics')">
          Aviso de Privacidad
        </h4>
        <span class="privacy bar nocookies">|</span>
        <h4 class="privacy clickable nocookies" @click="footerGA4Click('click', 'politica de cookies', 'footer') & $router.push('/cookies')">
          Política de Cookies
        </h4>
        <span class="privacy bar nomobile">|</span>
        <h4 class="privacy nomobile">213300201A0563</h4>
        <span class="privacy bar nomobile">|</span>
        <h4 class="privacy nomobile">Evita el Exceso</h4>
      </div>
      <div class="privacy-second">
        <h4 class="privacy nodesktop" @click="footerGA4Click('click', 'politica de cookies', 'footer') & $router.push('/cookies')">Política de Cookies</h4>
      </div>
      <div v-if="showInfoOption" class="privacy-second">
        <h4 class="privacy nodesktop" @click="(showModalInfo = true) & footerGA4Click('click', 'informacion del producto', 'footer')">Información del producto</h4>
      </div>
      <div class="privacy-second">      <h4 class="privacy nodesktop">213300201A0563</h4>
      <span class="privacy bar nodesktop">|</span>
      <h4 class="privacy nodesktop">Evita el Exceso</h4></div>
     
    </div>
    <div class="mSocialmedia-container">
      <a
        id="facebook"
        class="social-icon"
        target="_blank"
        href="https://www.facebook.com/cervezaindio/" @click="socialClick('Facebook','Interaction') & socialGA4Click('click', 'redes sociales :: facebook', 'footer')"
        ><img :src="fbIcon" alt="Facebook"
      /></a>
      <a
        id="instagram"
        class="social-icon"
        target="_blank"
        href="https://www.instagram.com/cervezaindio/" @click="socialClick('Instagram','Interaction') & socialGA4Click('click', 'redes sociales :: instagram', 'footer')"
        ><img :src="inIcon" alt="Instagram"
      /></a>
      <a
        id="twitter"
        class="social-icon"
        target="_blank"
        href="https://twitter.com/cervezaindio" @click="socialClick('Twitter','Interaction') & socialGA4Click('click', 'redes sociales :: twitter', 'footer')"
        ><img :src="twIcon" alt="Twitter"
      /></a>
      <a
        id="youtube"
        class="social-icon"
        target="_blank"
        href="https://www.youtube.com/user/cervezaindio" @click="socialClick('Youtube','Interaction') & socialGA4Click('click', 'redes sociales :: youtube', 'footer')"
        ><img :src="ytIcon" alt="Youtube"
      /></a>
    </div>
    <Modal
      v-if="showModal"
      v-bind:wichModal="wichModal"
      @close="showModal = false"
    />
    <ModalCookies v-if="showModalC" v-bind:wichModalC="wichModalC" @close="showModalC = false"/>
    <ModalInfo v-if="showModalInfo"  @close="showModalInfo = false"></ModalInfo>
  </div>
</template>

<script>
import Modal from "@/components/Modal";
import ModalCookies from "@/components/ModalCookies";
import indioIcon from "@/assets/Indio_Logo_Simple.png";
import fbIcon from "@/assets/fbIcon.png";
import twIcon from "@/assets/twIcon.png";
import ytIcon from "@/assets/ytIcon.png";
import inIcon from "@/assets/instaIcon.png";
import tagFunctions from '@/utils/tagFunctions.js'
import ModalInfo from '@/components/ModalInfoProduct';

const utm1 = {
  utm_content: "QR_AvisoAlcohol",
  utm_medium: "PopUp",
  utm_source: "Lata-Indio",
};
export default {
  name: "FooterHome",
  data() {
    return {
      showModal: false,
      wichModal: "tucos",
      showModalC: false,
      wichModalC: "tycos",
      indioIcon,
      fbIcon,
      twIcon,
      ytIcon,
      inIcon,
      showModalInfo: false,
      showInfoOption: false
    };
  },
  mounted() {
    const { utm_source, utm_medium, utm_content } = this.$route.query;
    if (
      utm1["utm_source"] === utm_source &&
      utm1["utm_content"] === utm_content &&
      utm1["utm_medium"] === utm_medium
    ) {
      setTimeout(() => {
        this.showInfoOption = true;
      }, 3000);
    }
  
  },
  methods: {
    popUpModal(modalType) {
      this.showModal = true;
      this.wichModal = modalType;
    },
    popUpModalC(modalTypeC) {
      this.showModalC = true;
      this.wichModalC = modalTypeC;
    },
    socialClick(socialNetwork, action){
      tagFunctions.evSocialNetworkPush(socialNetwork, action)
    },
    socialGA4Click(action, element, section) {
      tagFunctions.user_interactionPush(action, element, section)
    },
    footerGA4Click(action, element, section) {
      tagFunctions.user_interactionPush(action, element, section)
    },
  },
  components: {
    Modal,
    ModalCookies,
    ModalInfo
  },
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/FooterHome.scss";
</style>
